export interface Workspace {
  id: number;
  name: string;
  author: string;
  categoryID: number;
}

export interface Category {
  id: number;
  name: string;
  simulator: Simulators;
  workspaces: Workspace[];
}

export interface Workspaces {
  simulator: Simulators;
  categories: Category[];
  focused: Workspace;
}

export enum Simulators {
  NuHeat = 0,
  UWG5Nvent = 1,
}
